import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Dispatch, SetStateAction } from "react";

const RightArrow = ({ className }: { className: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5963 8.94538C17.2146 9.56371 17.2146 10.5662 16.5963 11.1846L12.4061 15.3748C12.0969 15.6839 11.5957 15.6839 11.2865 15.3748C10.9774 15.0656 10.9774 14.5644 11.2865 14.2552L14.685 10.8566L3.73173 10.8566C3.2945 10.8566 2.94006 10.5022 2.94006 10.065C2.94006 9.62776 3.2945 9.27332 3.73173 9.27332L14.6851 9.27332L11.2865 5.87478C10.9774 5.56561 10.9774 5.06436 11.2865 4.75519C11.5957 4.44602 12.0969 4.44602 12.4061 4.75519L16.5963 8.94538L16.0977 9.44395L16.5963 8.94538Z"
          fill="#FFF4E3"
        />
      </g>
    </svg>
  );
};

type ViewBtnProps = {
  pageNo: number;
  setPageNo: Dispatch<SetStateAction<number>>;
  loadingMore: boolean;
  text: string;
  reachedEnd: boolean;
};

export default function ViewAllBtn(props: ViewBtnProps) {
  const { setPageNo, loadingMore, text, reachedEnd } = props;
  return (
    <Button
      variant="outline"
      disabled={reachedEnd}
      className={cn(
        "mx-auto mt-10 flex gap-2 rounded-full p-6 text-secondary/80",
        reachedEnd ? "invisible" : "",
      )}
      onClick={() => setPageNo((prev) => prev + 1)}
      isLoading={loadingMore}
    >
      <span>{text}</span> <RightArrow className="rtl:rotate-180" />
    </Button>
  );
}
